import React from 'react';
import { ChevronDown, Shield, Network } from 'lucide-react';

const Hero = () => {
  const scrollToNext = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section className="min-h-screen bg-gradient-to-br from-gray-900 via-notaria-primary to-black flex items-center justify-center relative overflow-hidden">
      {/* Animated Background Grid */}
      <div className="absolute inset-0 tech-grid-bg opacity-30"></div>
      
      {/* Animated Particles */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-notaria-secondary rounded-full particle" style={{'--tx': '100px', '--ty': '-100px'}}></div>
        <div className="absolute top-1/3 right-1/4 w-3 h-3 bg-cyan-400 rounded-full particle" style={{'--tx': '-80px', '--ty': '80px'}}></div>
        <div className="absolute bottom-1/4 left-1/3 w-2 h-2 bg-notaria-secondary rounded-full particle" style={{'--tx': '60px', '--ty': '-60px'}}></div>
        <div className="absolute top-2/3 right-1/3 w-2 h-2 bg-cyan-300 rounded-full particle" style={{'--tx': '-100px', '--ty': '-80px'}}></div>
      </div>
      
      {/* Glowing Orbs */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-notaria-secondary/30 rounded-full blur-3xl animate-pulse-glow"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500/30 rounded-full blur-3xl animate-pulse-glow delay-1000"></div>
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Notaría / Equipo */}
          <div className="flex items-center justify-center gap-4 mb-6 animate-fade-in">
            <div className="flex items-center gap-2">
              <Shield className="w-8 h-8 text-cyan-400" />
              <span className="text-3xl md:text-4xl font-bold text-white">NOTARÍA</span>
            </div>
            <span className="text-3xl md:text-4xl font-bold text-cyan-400">/</span>
            <div className="flex items-center gap-2">
              <Network className="w-8 h-8 text-cyan-400" />
              <span className="text-3xl md:text-4xl font-bold text-white">EQUIPO</span>
            </div>
          </div>

          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight animate-fade-in delay-100">
            Seguridad Jurídica y Ecosistema Digital
          </h1>
          
          <p className="text-xl md:text-2xl text-cyan-300 font-medium mb-8 animate-fade-in delay-200">
            Donde la Fe Pública se une con la Fe Técnica a través del Blockchain
          </p>
          
          <p className="text-lg md:text-xl text-gray-300 mb-4 animate-fade-in delay-300">
            NOTARÍA 4.0 • LEGALTECH • BLOCKCHAIN • IA
          </p>

          <div className="mt-12 flex flex-col md:flex-row gap-4 justify-center items-center animate-fade-in delay-400">
            <div className="inline-block bg-white/10 backdrop-blur-sm px-8 py-4 rounded-lg border border-white/20 hover-lift">
              <p className="text-white text-lg font-medium">CERTIFICADOS EN ISO 9001:2015</p>
              <p className="text-gray-300 text-sm mt-2">Auditada y calificada bajo los estándares más exigentes</p>
            </div>
            
            <a 
              href="/whitepaper"
              className="inline-block bg-cyan-500 hover:bg-cyan-600 text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 hover:scale-105 shadow-lg"
            >
              📄 Ver Whitepaper Notaría 4.0
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce cursor-pointer hover:text-cyan-400 transition-colors"
        aria-label="Scroll down"
      >
        <ChevronDown size={40} />
      </button>
    </section>
  );
};

export default Hero;